module.exports = __webpack_public_path__ + "img/account_tax.1784e02c.svg";